var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.orgName)?_c('span',{style:('border-bottom: 5.28px solid ' + _vm.colour + '80')},[_c('b',{class:_vm.colour ? 'text-black' : 'text-black'},[_vm._v(_vm._s(_vm.orgName))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }